export const config = {
  appId: "35a49e38-fc73-44b5-8bff-e9f1b32e9d5f",
  // redirectUrl: "http://localhost:3000",
  //prod
  redirectUrl: "https://brtool.myemergencydr.com.au",
  scopes: ["user.read"],
  authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTHORITY}`,
};
